// Typed worker-outcome taxonomy — mirrors agent_runtime.outcome_classifier
// (zenyt-services) and the console backend's read-time fallback copy.

export const OUTCOME_CONFIG = {
  ok_findings: { label: "workers w/ findings", bg: "bg-green-100", text: "text-green-800", dot: "bg-green-500", failure: false },
  ok_no_findings: { label: "No findings", bg: "bg-gray-100", text: "text-gray-700", dot: "bg-gray-400", failure: false },
  wrong_surface: { label: "Wrong surface", bg: "bg-yellow-100", text: "text-yellow-800", dot: "bg-yellow-500", failure: false },
  blocked_cloudflare: { label: "Cloudflare", bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500", failure: true },
  mcp_timeout: { label: "MCP timeout", bg: "bg-purple-100", text: "text-purple-800", dot: "bg-purple-500", failure: true },
  tool_failure_other: { label: "Tool failure", bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500", failure: true },
  infra_error: { label: "Infra error", bg: "bg-red-100", text: "text-red-800", dot: "bg-red-500", failure: true },
  budget_exceeded: { label: "Budget", bg: "bg-pink-100", text: "text-pink-800", dot: "bg-pink-500", failure: true },
  killed: { label: "Killed", bg: "bg-red-100", text: "text-red-800", dot: "bg-red-600", failure: true },
  unknown_failure: { label: "Unknown", bg: "bg-gray-100", text: "text-gray-500", dot: "bg-gray-400", failure: true },
};

export const RUN_STATUS_CONFIG = {
  running: { label: "Running", bg: "bg-blue-100", text: "text-blue-800", pulse: true },
  completed: { label: "Completed", bg: "bg-green-100", text: "text-green-800", pulse: false },
  failed: { label: "Failed", bg: "bg-red-100", text: "text-red-800", pulse: false },
  orphaned: { label: "Orphaned", bg: "bg-orange-100", text: "text-orange-800", pulse: false },
  // Hub Stop → session killed. Run row often lands as failed; API stamps
  // `stopped: true` so we can show the same "Stopped" signal Hub customers see.
  stopped: { label: "Stopped", bg: "bg-amber-100", text: "text-amber-800", pulse: false },
};

/** Prefer Stopped when the orchestrator session was operator-killed. */
export function displayRunStatus(run) {
  if (run?.stopped || (run?.session_status || "").toLowerCase() === "killed") {
    return "stopped";
  }
  return run?.status || "";
}

export function outcomeCfg(cls) {
  return (
    OUTCOME_CONFIG[cls] || {
      label: cls || "?",
      bg: "bg-gray-100",
      text: "text-gray-500",
      dot: "bg-gray-400",
      failure: false,
    }
  );
}

export function formatUsd(v) {
  const n = Number(v || 0);
  return `$${n >= 10 ? n.toFixed(1) : n.toFixed(2)}`;
}

export function formatDuration(seconds) {
  if (seconds == null) return "—";
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;
  const diff = Math.max(0, Date.now() - then);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
}
